import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import { getSwimLaneHeader } from '@/common/swim-lane';
import { showLoading, hideLoading } from '@/utils/loading';
import Toast from '@/components/toast';
import { useK18n } from '@/common/k18n';
var service = axios.create({
  baseURL: '/',
  timeout: 30 * 1000,
  headers: _objectSpread({}, getSwimLaneHeader()),
  showLoading: true,
  silent: false
});
// 添加请求拦截器
service.interceptors.request.use(function (config) {
  // 判断当前请求是否设置了不显示Loading
  if (config.showLoading && !config.silent) {
    showLoading();
  }
  return config;
});
service.interceptors.response.use(function (response) {
  var data = response.data,
    config = response.config;
  var showLoading = config.showLoading,
    silent = config.silent;
  if (showLoading && !silent) {
    hideLoading();
  }
  if ((data === null || data === void 0 ? void 0 : data.result) !== 1 && !silent) {
    var _response$data, _response$data2, _response$data3;
    var $k18n = useK18n();
    var msg = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.error_msg) || (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.msg) || (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.ztMsg) || $k18n('未知错误');
    msg && Toast.info(msg);
    console.warn('xhr error', config, data);
  }
  return Promise.resolve(data);
}, function (error) {
  var response = error.response;
  if (response) {
    var _response$config = response === null || response === void 0 ? void 0 : response.config,
      _showLoading = _response$config.showLoading,
      silent = _response$config.silent;
    if (_showLoading && !silent) {
      hideLoading();
    }
    if (!silent) {
      Toast.info(error);
    }
  } else {
    hideLoading();
    Toast.info(error);
  }
});
/**
 * res.result !== 1 reject
 */
export function resultCodeCheck(_x) {
  return _resultCodeCheck.apply(this, arguments);
}
function _resultCodeCheck() {
  _resultCodeCheck = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(res.result === 1)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", res);
          case 2:
            return _context.abrupt("return", Promise.reject(res));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resultCodeCheck.apply(this, arguments);
}
export default service;